import * as React from 'react';
import * as styles from './styles.scss';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import type { BucketPayload } from 'owa-timestream-asset-sdk-bucket';
import { observer } from 'mobx-react-lite';
import BucketChildren from './BucketChildren';
import BucketViewTitle from './BucketViewTitle';
import EmptyBucketDropTarget from './EmptyBucketDropTarget';

export default observer(function BucketView({
    childrenAssets,
    payload: { name, charmId },
    color,
    DueDate,
    Options,
}: AssetCommonViewProps<BucketPayload>) {
    const hasChildren = childrenAssets && childrenAssets.length != 0;

    return (
        <div>
            <BucketViewTitle name={name} charmId={charmId} color={color} />
            <div className={styles.options}>{Options}</div>
            <div className={styles.dueDateContainer}>{DueDate}</div>
            {hasChildren ? (
                <BucketChildren childrenAssets={childrenAssets!} />
            ) : (
                <EmptyBucketDropTarget />
            )}
        </div>
    );
});
